var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page product-page-typography" },
    [
      _c("section", { staticClass: "intro" }, [
        _c("div", { staticClass: "container" }, [
          _c(
            "div",
            { staticClass: "grid4-img" },
            [
              _c("ResponsiveImg", {
                staticClass: "grid4-img__image intro__image",
                attrs: {
                  imgClass: "img__bitrix-telegram img__bitrix-whatsapp--1",
                  path: "bitrix-instagram",
                  name: "main",
                  alt: "Instagram in Bitrix24, Umnico Widget",
                  isNotLazy: true,
                  htmlWidth: "620",
                  htmlHeight: "515",
                  fetchpriority: "high",
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "grid4-img__head intro__head" }, [
                _c("h1", {
                  staticClass:
                    "intro__header intro__header heading-primary red-i",
                  domProps: {
                    innerHTML: _vm._s(_vm.$t(`__bitrix_instagram_main_title`)),
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "grid4-img__text intro__text" }, [
                _c("p", { staticClass: "paragraph-primary" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("__bitrix_instagram_main_description_1")) +
                      "\n                    "
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "paragraph-primary" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("__bitrix_instagram_main_description_2")) +
                      "\n                    "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "grid4-img__btn intro__btn" }, [
                _c(
                  "div",
                  { staticClass: "intro__buttons" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "brand-button brand-button--red",
                        attrs: { to: _vm.ROUTES.REGISTER },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.$t("__bitrix_instagram_button_try_free")
                            ) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "interactive" }, [
        _c(
          "div",
          { staticClass: "container" },
          [
            _c("Advantages", {
              attrs: {
                list: _vm.advantagesList,
                isSwitchableDescription: true,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "page__block" },
        [
          _c("BlockClientsGrey", {
            attrs: {
              center: true,
              list: ["sber", "kia", "invitro", "dhl", "raif"],
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "container" },
        [
          _c("BlueBoxWithText", {
            attrs: { title: _vm.aboutList.title, texts: _vm.aboutList.texts },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("section", { staticClass: "about-problem" }, [
        _c("div", { staticClass: "container" }, [
          _c(
            "div",
            { staticClass: "about-problem__inner" },
            [
              _c(
                "h3",
                { staticClass: "about-problem__title heading-tertiary" },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.$t("__bitrix_instagram_problem_solution_title")
                      ) +
                      "\n                "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("Advantages", {
                attrs: {
                  list: _vm.problemsList,
                  isSwitchableDescription: false,
                  headerClass: "about-problem__header",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("Quiz", {
            attrs: { title: _vm.$t(`__bitrix_instagram_quiz_title`) },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("section", { staticClass: "outlined-block" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "outlined-block__inner" }, [
            _c("h2", {
              staticClass: "outlined-block__title heading-secondary red-i",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("__bitrix_instagram_customer_requests_title")
                ),
              },
            }),
            _vm._v(" "),
            _c("p", { staticClass: "outlined-block__text paragraph-primary" }, [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.$t("__bitrix_instagram_customer_requests_text_1")
                  ) +
                  "\n                "
              ),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "outlined-block__text paragraph-primary" }, [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.$t("__bitrix_instagram_customer_requests_text_2")
                  ) +
                  "\n                "
              ),
            ]),
            _vm._v(" "),
            _c("img", {
              staticClass: "outlined-block__corner-img",
              attrs: {
                src: _vm.instagramTransparentIcon,
                alt: "Instagram icon",
                width: "125",
                height: "125",
              },
            }),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "opportunities page__block" },
        [
          _c("div", { staticClass: "container opportunities__indent" }, [
            _c("h2", {
              staticClass: "opportunities__title heading-secondary red-i",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t(`__bitrix_instagram_opportunities_title`)
                ),
              },
            }),
            _vm._v(" "),
            _c("p", {
              staticClass: "opportunities__text paragraph-primary",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("__bitrix_instagram_opportunities_text")
                ),
              },
            }),
          ]),
          _vm._v(" "),
          _c("BlockInteg2Side", {
            staticClass: "two-side two-side-gaps",
            attrs: {
              header: _vm.$t("__bitrix_instagram_connect_title"),
              plist: [
                _vm.$t("__bitrix_instagram_connect_text_1"),
                _vm.$t("__bitrix_instagram_connect_text_2"),
              ],
              path: "bitrix-instagram",
              image: "instagram-1",
              imgClass:
                "img__bitrix-instagram img__bitrix-instagram--picture-1",
              reverse: true,
              width: "460",
              height: "345",
              alt: "Connect any number of Instagram accounts to Bitrix24 with Umnico",
            },
          }),
          _vm._v(" "),
          _c("BlockInteg2Side", {
            staticClass: "two-side two-side-gaps two-side__right",
            attrs: {
              header: _vm.$t("__bitrix_instagram_send_title"),
              plist: [
                _vm.$t("__bitrix_instagram_send_text_1"),
                _vm.$t("__bitrix_instagram_send_text_2"),
              ],
              path: "bitrix-instagram",
              image: "instagram-2",
              imgClass:
                "img__bitrix-instagram img__bitrix-instagram--picture-2",
              reverse: false,
              width: "430",
              height: "405",
              alt: "Umnico - one widget to process all inquiries in Bitrix24",
            },
          }),
          _vm._v(" "),
          _c("BlockInteg2Side", {
            staticClass: "two-side two-side-gaps",
            attrs: {
              header: _vm.$t("__bitrix_instagram_reply_title"),
              plist: [
                _vm.$t("__bitrix_instagram_reply_text_1"),
                _vm.$t("__bitrix_instagram_reply_text_2"),
              ],
              path: "bitrix-instagram",
              image: "instagram-3",
              imgClass:
                "img__bitrix-instagram img__bitrix-instagram--picture-3",
              reverse: true,
              width: "460",
              height: "351",
              alt: "Response to mentionings in Stories and comments in your posts with Bitrix24",
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "crms-cta--small block-mb" }, [
            _c("div", { staticClass: "container" }, [
              _c("div", { staticClass: "crms-cta__container" }, [
                _c("div", { staticClass: "crms-cta__inner" }, [
                  _c("div", { staticClass: "crms-cta__body" }, [
                    _c("div", { staticClass: "crms-cta__img" }, [
                      _c("img", {
                        staticClass: "crms-cta__amo_whatsapp-icon",
                        attrs: {
                          src: _vm.instagramBigIcon,
                          alt: "Telegram logo",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "crms-cta__text" }, [
                      _c(
                        "p",
                        { staticClass: "crms-cta__title heading-tertiary" },
                        [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(
                                _vm.$t("__bitrix_instagram_banner_title")
                              ) +
                              "\n                                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticClass:
                            "crms-cta__description paragraph-primary",
                        },
                        [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.$t("__bitrix_instagram_banner_text")) +
                              "\n                                "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "crms-cta__button" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass:
                              "crms-cta__link brand-button brand-button--red",
                            attrs: { to: _vm.ROUTES.REGISTER },
                          },
                          [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(
                                  _vm.$t("__bitrix_instagram_button_try_free")
                                ) +
                                "\n                                "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("BlockInteg2Side", {
            staticClass: "two-side two-side-gaps two-side__right",
            attrs: {
              header: _vm.$t("__bitrix_instagram_automatic_title"),
              plist: [
                _vm.$t("__bitrix_instagram_automatic_text_1"),
                _vm.$t("__bitrix_instagram_automatic_text_2"),
              ],
              path: "bitrix-instagram",
              image: "instagram-4",
              imgClass:
                "img__bitrix-instagram img__bitrix-instagram--picture-4",
              reverse: false,
              width: "376",
              height: "370",
              alt: "An automatic welcome message to greet new clients with Bitrix24",
            },
          }),
          _vm._v(" "),
          _c("BlockInteg2Side", {
            staticClass: "two-side two-side-gaps",
            attrs: {
              header: _vm.$t("__bitrix_instagram_expand_title"),
              plist: [
                _vm.$t("__bitrix_instagram_expand_text_1"),
                _vm.$t("__bitrix_instagram_expand_text_2"),
              ],
              path: "bitrix-instagram",
              image: "instagram-5",
              imgClass:
                "img__bitrix-instagram img__bitrix-instagram--picture-5",
              reverse: true,
              width: "430",
              height: "340",
              alt: "Supervise your staff and monitor communication performance in Bitrix24",
            },
          }),
          _vm._v(" "),
          _c("BlockInteg2Side", {
            staticClass: "two-side two-side__right two-side-last",
            attrs: {
              imgClass: "img__bitrix-whatsapp two-side__image-inner",
              header: _vm.$t("__bitrix_instagram_engage_title"),
              plist: [
                _vm.$t("__bitrix_instagram_engage_text_1"),
                _vm.$t("__bitrix_instagram_engage_text_2"),
              ],
              path: "bitrix-instagram",
              image: "instagram-6",
              reverse: false,
              width: "460",
              height: "355",
              alt:
                _vm.lang === "ru"
                  ? "Chat with a customer through Instagram Direct in Bitrix24 with no VPN "
                  : "Bitrix24 app and Instagram integration by Umnico to chat with clients on the go",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "advantages-grid advantages--is-main" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "advantages-grid__container" }, [
            _c(
              "div",
              { staticClass: "advantages-grid__item item-blue item-a" },
              [
                _c("h2", [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("__bitrix_instagram_grid_item_1")) +
                      "\n                    "
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "advantages-grid__item item-b" },
              [
                _c("div", {
                  staticClass: "advantages-grid__item-title",
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("__bitrix_instagram_grid_item_2")),
                  },
                }),
                _vm._v(" "),
                _c("ResponsiveImg", {
                  staticClass: "item-b__img",
                  attrs: {
                    alt: "Chat to deal switching",
                    path: "amocrm-whatsapp",
                    name: "amocrm-whatsapp-11",
                    htmlHeight: "97",
                    htmlWidth: "203",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "advantages-grid__item item-blue item-c" },
              [
                _c("div", {
                  staticClass: "advantages-grid__item-title item-c__title",
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("__bitrix_instagram_grid_item_3")),
                  },
                }),
                _vm._v(" "),
                _c("ResponsiveImg", {
                  staticClass: "item-c__img",
                  attrs: {
                    alt: "Filters and block lists",
                    path: "bitrix-instagram",
                    name: "instagram-7",
                    htmlHeight: "190",
                    htmlWidth: "230",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "advantages-grid__item item-d" }, [
              _c("div", {
                staticClass: "advantages-grid__item-title",
                domProps: {
                  innerHTML: _vm._s(_vm.$t("__bitrix_instagram_grid_item_4")),
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "advantages-grid__item-bottom" },
                [
                  _c("ResponsiveImg", {
                    attrs: {
                      alt: "Message citation",
                      path: "bitrix-instagram",
                      name: "instagram-8",
                      htmlHeight: "151",
                      htmlWidth: "213",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "advantages-grid__item item-blue item-e" },
              [
                _c("div", {
                  staticClass: "advantages-grid__item-title",
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("__bitrix_instagram_grid_item_5")),
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "advantages-grid__item-bottom img-inner-shadow",
                  },
                  [
                    _c("ResponsiveImg", {
                      attrs: {
                        path: "bitrix-instagram",
                        name: "instagram-9",
                        alt: "Application settings",
                        htmlHeight: "215",
                        htmlWidth: "462",
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "advantages-grid__item item-blue item-f" },
              [
                _c("div", {
                  staticClass: "advantages-grid__item-title item-f__title",
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("__bitrix_instagram_grid_item_6")),
                  },
                }),
                _vm._v(" "),
                _c("ResponsiveImg", {
                  attrs: {
                    imgClass: "item-f__img",
                    alt: "Cross-channel reply",
                    path: "bitrix-instagram",
                    name: "instagram-10",
                    htmlHeight: "164",
                    htmlWidth: "302",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "advantages-grid__item item-blue item-g" },
              [
                _c("div", {
                  staticClass: "advantages-grid__item-title",
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("__bitrix_instagram_grid_item_7")),
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "advantages-grid__item-bottom item-g__container",
                  },
                  [
                    _c("img", {
                      staticClass: "item-g__img",
                      attrs: { src: _vm.quickSearch, alt: "Message search" },
                    }),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "advantages-grid__item item-h" },
              [
                _c("div", {
                  staticClass: "advantages-grid__item-title",
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("__bitrix_instagram_grid_item_8")),
                  },
                }),
                _vm._v(" "),
                _c("ResponsiveImg", {
                  attrs: {
                    imgClass: "item-f__img",
                    alt: "Chat access management",
                    path: "bitrix-instagram",
                    name: "instagram-11",
                    htmlHeight: "154",
                    htmlWidth: "301",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "amo-whatsapp-table" }, [
        _c(
          "div",
          { staticClass: "container" },
          [
            _c(
              "h2",
              { staticClass: "amo-whatsapp-table__title heading-secondary" },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("__bitrix_instagram_table_title")) +
                    "\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "p",
              { staticClass: "amo-whatsapp-table__text paragraph-primary" },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("__bitrix_instagram_table_text")) +
                    "\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _c("Table", {
              attrs: { theme: "rounded", tableData: _vm.btWaTable },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("HowConnectStep", {
        staticClass: "how-connect page__block custom-link",
        attrs: {
          title: _vm.howConnect.title,
          isSlotUsed: true,
          videoPlayer: _vm.videoLink,
        },
        scopedSlots: _vm._u(
          [
            _vm.lang === "ru" || _vm.lang === "en"
              ? {
                  key: "step1",
                  fn: function () {
                    return [
                      _c(
                        "router-link",
                        { attrs: { to: _vm.ROUTES.REGISTER } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "__bitrix_instagram_how_connect_step_1_link"
                              )
                            )
                          ),
                        ]
                      ),
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t("__bitrix_instagram_how_connect_step_1")
                          ) +
                          "\n        "
                      ),
                    ]
                  },
                  proxy: true,
                }
              : {
                  key: "step1",
                  fn: function () {
                    return [
                      _c(
                        "router-link",
                        { attrs: { to: _vm.ROUTES.REGISTER } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "__bitrix_instagram_how_connect_step_1_link"
                              )
                            )
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
            {
              key: "step2",
              fn: function () {
                return [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("__bitrix_instagram_how_connect_step_2")) +
                      "\n        "
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "step3",
              fn: function () {
                return [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$t("__bitrix_instagram_how_connect_step_3_1")
                      ) +
                      "\n            "
                  ),
                  _c("a", { attrs: { href: _vm.appLink, target: "_blank" } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$t("__bitrix_instagram_how_connect_step_3_link")
                        ) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$t("__bitrix_instagram_how_connect_step_3_2")
                      ) +
                      "\n        "
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "text",
              fn: function () {
                return [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("__bitrix_instagram_how_connect_text_1")) +
                      "\n            "
                  ),
                  _c(
                    "router-link",
                    { attrs: { to: _vm.ROUTES.HELP_CENTER_CRM_B24_INSTAGRAM } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("__bitrix_instagram_how_connect_text_link")
                        )
                      ),
                    ]
                  ),
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("__bitrix_instagram_how_connect_text_2")) +
                      "\n        "
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
      _vm._v(" "),
      _c("BlockDevelopRate", {
        attrs: {
          header: _vm.i18n("__bitrix_instagram_rate_title"),
          headDesc: _vm.i18n(`__bitrix_instagram_rate_subtitle`),
          subHeader: _vm.$t("__common_price_sentence_variant_4", _vm.price),
          desc: _vm.i18n("__bitrix_instagram_rate_description"),
          btnTextRate: _vm.i18n("__bitrix_instagram_rate_button_1"),
          btnTry: _vm.i18n("__bitrix_instagram_button_try_free"),
          noShadow: true,
          btnClasses1: "brand-button brand-button--red-outline",
          btnClasses2: "brand-button brand-button--red",
        },
      }),
      _vm._v(" "),
      _c("section", { staticClass: "about-integrations" }, [
        _c("div", { staticClass: "container" }, [
          _c(
            "div",
            { staticClass: "about-integrations__inner" },
            [
              _c(
                "h2",
                { staticClass: "about-integrations__title heading-secondary" },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("__bitrix_instagram_integrations_title")) +
                      "\n                "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "p",
                { staticClass: "about-integrations__text paragraph-primary" },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("__bitrix_instagram_integrations_text")) +
                      "\n                "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("Advantages", {
                attrs: {
                  list: _vm.integrationsList,
                  isSwitchableDescription: false,
                  headerAsLink: true,
                  headerClass: "about-integrations__header",
                  descriptionClass: "about-integrations__description",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("FAQ", {
        staticClass: "page__block faq-padding faq",
        attrs: {
          title: _vm.$t("__bitrix_instagram_faq_header"),
          description: _vm.$t("__bitrix_instagram_faq_description"),
          items: _vm.faqList,
          color: "#FE1B51",
        },
      }),
      _vm._v(" "),
      _vm.lang === "ru"
        ? _c("section", [
            _c("div", { staticClass: "container" }, [
              _c("p", { staticClass: "disclaimer" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("__integration_disclaimer")) +
                    "\n            "
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("CTARegistration", {
        attrs: {
          bgColor: "#001933",
          pseudoColor: "#1C92FF",
          title: _vm.CTARegestationList.title,
          texts: [
            _vm.lang !== "de"
              ? _vm.$t("__bitrix_instagram_cta_registration_text")
              : "",
          ],
          button: _vm.CTARegestationList.button,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }